export default function BrandLogo({ src, testId, className = "" }) {
  return (
    <img
      className={`brand-logo-image ${className}`}
      src={src}
      alt="Vincent General Construction Inc. logo"
      data-testid={testId}
    />
  );
}
